import { useEffect, useMemo, useState } from "react";
import useWilmaCustomers from "../../../data/useWilmaCustomers";
import { ICustomerName } from "../../../models/ICustomer";


function hexToRgba(hex: string, alpha: number) {
  const h = hex.replace("#", "");
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  const int = parseInt(full, 16);
  const r = (int >> 16) & 255;
  const g = (int >> 8) & 255;
  const b = int & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export default function QuoteOwnerPill({ 
  customerId,
  showLabel = true,
  label = "Owner",
}: { customerId: string | null, showLabel?: boolean, label?: string }) {
  const { customers } = useWilmaCustomers();
  const [customer, setCustomer] = useState<ICustomerName | null>(null);

  useEffect(() => {
    if (!customers.isLoading && customers.data) {
      const found = customers.data.data.find((c) => c.id === customerId);
      setCustomer(found || null);
    }
  }, [customers.data, customerId, customers.isLoading]);

  const brand = customer?.primaryColour || "#6B7280"; // gray fallback

  const styles = useMemo(
    () => ({
      backgroundColor: hexToRgba(brand, 0.10),
      borderColor: hexToRgba(brand, 0.25),
      color: brand,
    }),
    [brand]
  );

  if (!customerId) return null;

  return (
    <span
      className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-sm font-medium border"
      style={styles}
      title={customer?.name || customerId}
    >
      {showLabel && <span className="text-xs opacity-80">{label}</span>}
      <span className="truncate max-w-[180px] font-semibold">
        {customer?.name || customerId}
      </span>
    </span>
  );
}